import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const todayStart = dayjs().startOf('day').toISOString();
const todayEnd = dayjs().endOf('day').toISOString();

const initialState = {
  salesPagination: {
    current: 1,
    pageSize: 20,
  },
  searchText: '',
  filterReference: '',
  filterStatus: null,
  filterCustomer: null,
  filterStore: null,
  saleDateRange: [todayStart, todayEnd],
};

const salesFiltersSlice = createSlice({
  name: 'salesFilters',
  initialState,
  reducers: {
    setSalesPagination: (state, action) => {
      state.salesPagination = action.payload;
    },
    setSalesSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setSalesFilterReference: (state, action) => {
      state.filterReference = action.payload;
    },
    setSalesFilterStatus: (state, action) => {
      state.filterStatus = action.payload;
    },
    setSalesFilterCustomer: (state, action) => {
      state.filterCustomer = action.payload;
    },
    setSalesFilterStore: (state, action) => {
      state.filterStore = action.payload;
    },
    setSalesDateRange: (state, action) => {
      state.saleDateRange = action.payload;
    },
    resetSalesFilters: () => initialState,
  },
});

export const {
  setSalesPagination,
  setSalesSearchText,
  setSalesFilterReference,
  setSalesFilterStatus,
  setSalesFilterCustomer,
  setSalesFilterStore,
  setSalesDateRange,
  resetSalesFilters,
} = salesFiltersSlice.actions;

export default salesFiltersSlice.reducer;